var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusTerminate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0.5C2.67188 0.5 0 3.19531 0 6.5C0 9.82812 2.67188 12.5 6 12.5C9.30469 12.5 12 9.82812 12 6.5C12 3.19531 9.30469 0.5 6 0.5ZM1.5 6.5C1.5 5.53906 1.80469 4.64844 2.32031 3.89844L8.60156 10.1797C7.85156 10.6953 6.96094 11 6 11C3.51562 11 1.5 8.98438 1.5 6.5ZM9.65625 9.125L3.375 2.84375C4.125 2.32812 5.01562 2 6 2C8.46094 2 10.5 4.03906 10.5 6.5C10.5 7.48438 10.1719 8.375 9.65625 9.125Z",
    fill: "#566478"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusTerminate);
export default __webpack_public_path__ + "static/media/status-terminate.cb8f7cd960d01f9ce9057f5c96e7e885.svg";
export { ForwardRef as ReactComponent };